import { Box, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';

import { DataAPIContext } from '../../api';
import { GET_LIST } from '../../api/dataProvider';

// Change-history tab for a blacklist rule. Reads the dedicated change log
// (/blacklist_rule/{id}/history/) which stores the mandatory reason for every
// create / update / delete.
const BlacklistHistory = ({ ruleId, active }) => {
    const dataAPI = React.useContext(DataAPIContext);
    const [loading, setLoading] = React.useState(false);
    const [rows, setRows] = React.useState([]);
    const [error, setError] = React.useState(null);

    React.useEffect(() => {
        if (!active || !ruleId) return;
        let cancelled = false;
        setLoading(true);
        setError(null);
        dataAPI(GET_LIST, 'blacklist_rule', {
            urlSuffix: `${ruleId}/history/`,
            pagination: { page: 1, perPage: 200 },
            sort: { field: 'created_ts', order: 'DESC' },
            filter: {},
        })
            .then((res) => {
                if (!cancelled) setRows(res.data || []);
            })
            .catch(() => {
                if (!cancelled) setError('Failed to load change history');
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, [dataAPI, ruleId, active]);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                <CircularProgress size={28} />
            </Box>
        );
    }
    if (error) {
        return <Typography color="error" sx={{ p: 2 }}>{error}</Typography>;
    }
    if (!rows.length) {
        return <Typography sx={{ p: 2 }} color="textSecondary">No change history yet.</Typography>;
    }

    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell>When</TableCell>
                    <TableCell>Action</TableCell>
                    <TableCell>By</TableCell>
                    <TableCell>Reason</TableCell>
                    <TableCell>Changed fields</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map((r) => (
                    <TableRow key={r.id}>
                        <TableCell>{r.created_ts ? moment(r.created_ts).format('YYYY-MM-DD HH:mm') : '—'}</TableCell>
                        <TableCell style={{ textTransform: 'capitalize' }}>{r.action}</TableCell>
                        <TableCell>{r.actor ? r.actor.email || r.actor.name : '—'}</TableCell>
                        <TableCell>{r.reason || '—'}</TableCell>
                        <TableCell>
                            {r.changed_fields
                                ? Object.keys(r.changed_fields).join(', ')
                                : (r.action === 'created' ? '(initial)' : '—')}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default BlacklistHistory;
